import React, { Component } from 'react';

export default class OwnerCertificate extends Component<any, any> {
  render() {
    return (
      <div className="content">
        <div className="content-box">
          <div className="content-main">
            ผู้เอาประกันภัย
            <p className="content-sub">
              {this.props.customer.firstName} {this.props.customer.lastName}
            </p>
          </div>
          <div className="content-left content-main">
            จำนวนใบรับรอง
            <p className="content-sub">
              <span>{this.props.policyCount}</span> ฉบับ
            </p>
          </div>
        </div>
      </div>
    );
  }
}
